export const GET_DMX_OCCUPANCY = 'GET_DMX_OCCUPANCY';
export const GET_DMX_OCCUPANCY_SUCCESS = 'GET_DMX_OCCUPANCY_SUCCESS';
export const GET_DMX_OCCUPANCY_ERROR = 'GET_DMX_OCCUPANCY_ERROR';
